export default
/* glsl */
"\nToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\n";